import { get } from '.'

export function GetCallTranscriptions(options = {}) {
    return get<any>("/app/api/call_transcriptions", options)
}

export function FindCallTranscription(vid) {
    return get<any>("/app/api/call_transcriptions/" + vid);
}

export function GetOutgoingCallTranscription(options = {}) {
    return get<any>("/app/api/call_transcriptions/outgoing_call_transcription", options)
}